import { GET_VENDOR_LOGOUT_REQUEST, GET_VENDOR_LOGOUT_SUCCESS } from "./type";

const initialState = {
    logoutUser: null,
    error: null,
    loading: false,
};

const VendorLogoutReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_VENDOR_LOGOUT_REQUEST:
            return {
                ...state,
                logoutUser: null,
                loading: true,
                error: null,
            };
        case GET_VENDOR_LOGOUT_SUCCESS:
            return {
                ...state,
                logoutUser: action.payload,
                loading: false,
                error: null,
            };
        default:
            return state;
    }
};

export default VendorLogoutReducer;
